module.exports = __webpack_public_path__ + "static/media/item_sli_pin_des.69d5f79a.png";